import { createContext } from 'react';

const helpContext = createContext();

export default helpContext;